/** A linked system user's Microsoft 365 account status (`m365Properties.accountStatus`), from the latest snapshot. */
export const M365_ACCOUNT_STATUSES = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
  // Missing from the tenant
  DELETED: 'deleted',
  // Shown instead of deleted while a Technical Primary keeps the role through the deleted grace period
  NOT_FOUND: 'not_found',
}

// The status as a value, such as an export cell or a detail row labelled with Microsoft 365.
const STATUS_MESSAGE_IDS = {
  [M365_ACCOUNT_STATUSES.ENABLED]: 'GENERAL.ENABLED',
  [M365_ACCOUNT_STATUSES.DISABLED]: 'GENERAL.DISABLED',
  [M365_ACCOUNT_STATUSES.DELETED]: 'SYSTEM_USERS.M365.DELETED_FROM_TENANT',
  [M365_ACCOUNT_STATUSES.NOT_FOUND]: 'SYSTEM_USERS.M365.NOT_FOUND',
}

// A shown status that will cost a Technical Primary the role once its grace period ends, as a pill beside their badge.
const GRACE_PERIOD_PILL_MESSAGE_IDS = {
  [M365_ACCOUNT_STATUSES.DISABLED]: 'SYSTEM_USERS.M365.DISABLED_IN_M365',
  [M365_ACCOUNT_STATUSES.NOT_FOUND]: 'SYSTEM_USERS.M365.NOT_FOUND',
}

/**
 * The account status to show. A Technical Primary whose account is missing from the tenant is still within the
 * deleted grace period, since the collection after it ends removes the role, so their account shows as not found.
 */
export const getShownM365AccountStatus = (accountStatus, isTechnicalPrimary) => {
  if (isTechnicalPrimary && accountStatus === M365_ACCOUNT_STATUSES.DELETED) return M365_ACCOUNT_STATUSES.NOT_FOUND
  return accountStatus ?? null
}

/** @returns {string | null} The status's message id, or null when it is unknown */
export const getM365AccountStatusMessageId = (status) => STATUS_MESSAGE_IDS[status] ?? null

/** @returns {string | null} The grace period pill's message id for a shown status, or null when there is none */
export const getGracePeriodPillMessageId = (status) => GRACE_PERIOD_PILL_MESSAGE_IDS[status] ?? null
